import { DateUrlParamsFilter } from '../../entities/filters/date-url-params-filter';
import { SimpleParamFilter } from '../../shared/ui/param-filters/simple-param-filter';
import { useOurCompany } from '../../hooks/portal-settings.hook';
import { LegalEntityParamFilter } from '../../entities/legal-entities/legal-entity-param-filter';
import { INVOICE_STATUSES_ARRAY } from '@sr/dto';
import { ManagerUrlParamsFilter } from 'entities/filters/manager-url-params-filter';
import { FilterWrapper, ValueFormatterContext } from '../../shared/ui/filter/filter-wrapper';
import { Stack } from '@mui/material';
import { useManagersDropdownList } from 'features/user/user-picker/ui';
import { useSearchParams } from 'react-router-dom';
import { useLegalEntityLabel } from 'shared/hooks/use-entity-labels';

export const WccBulkCreateFilter = () => {
  const ourCompanyId = useOurCompany();
  const { items: managers } = useManagersDropdownList();
  const [searchParams] = useSearchParams();
  const selectedLegalEntityId = searchParams.get('ourLegalEntityId');
  const legalEntityLabel = useLegalEntityLabel(selectedLegalEntityId);

  const managerValueFormatter = ({ value }: ValueFormatterContext) => {
    const manager = managers.find((m) => String(m.id) === value);
    return manager ? `${manager.firstName} ${manager.secondName || ''}`.trim() : value;
  };

  const legalEntityFormatter = ({ value }: ValueFormatterContext) => {
    if (legalEntityLabel && selectedLegalEntityId === value) {
      return legalEntityLabel;
    }
    return value;
  };

  const statusMap = new Map(INVOICE_STATUSES_ARRAY.map((item) => [String(item.id), item.label]));
  const statusFormatter = ({ value }: ValueFormatterContext) => statusMap.get(String(value)) ?? value;

  return (
    <FilterWrapper>
      <FilterWrapper.Item label="Наше юрлицо" queryKeys="ourLegalEntityId" valueFormatter={legalEntityFormatter}>
        <LegalEntityParamFilter queryParamName={'ourLegalEntityId'} label="Наше юрлицо" companyId={ourCompanyId} />
      </FilterWrapper.Item>

      <FilterWrapper.Item label="Менеджер" queryKeys="managerId" valueFormatter={managerValueFormatter}>
        <ManagerUrlParamsFilter queryParamName="managerId" />
      </FilterWrapper.Item>

      <FilterWrapper.Item label="Статус" queryKeys="statusId" valueFormatter={statusFormatter}>
        <SimpleParamFilter queryParamName="statusId" items={INVOICE_STATUSES_ARRAY} label="Статус" />
      </FilterWrapper.Item>

      <FilterWrapper.Item
        label="Дата окончания"
        queryKeys={['fromDate', 'toDate']}
        summaryFormatter={({ searchParams }) => {
          const from = searchParams.get('fromDate');
          const to = searchParams.get('toDate');
          if (!from && !to) return 'Дата окончания';
          if (from && to) return `Дата: ${from} — ${to}`;
          return `Дата: ${from || to}`;
        }}
      >
        <Stack spacing={1.5}>
          <DateUrlParamsFilter queryParamName={'fromDate'} label="Дата окончания с " />
          <DateUrlParamsFilter queryParamName={'toDate'} label="Дата окончания по" />
        </Stack>
      </FilterWrapper.Item>
    </FilterWrapper>
  );
};
